<!--
  Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
@if (permission()) {
<div class="icd-subscriptions-container">
    <div class="page-header">
        <h2>My ICD Subscriptions</h2>
        <p class="page-subtitle">
            Subscribe to individual ICDs or a Program + Model Year group to get notified by email when they change.
            Notifications rely on ICD history tracking, so only Stage 2 and above ICDs will trigger a notification.
        </p>
    </div>

    <div class="form-card">
        <h3>Add ICD</h3>
        <div class="add-icd-row">
            <label>
                ICD ID
                <input class="form-input" type="number" [(ngModel)]="newIcdId" [disabled]="saving"/>
            </label>
            <p-button label="Add ICD" type="button" (click)="addIndividualSubscription()" [disabled]="saving"></p-button>
        </div>
    </div>

    <div class="form-card">
        <h3>Add Program + Model Year</h3>
        <p class="form-note">
            Subscribing to a Program + Model Year automatically includes any ICD created later that matches it.
        </p>
        <div class="add-group-row">
            <label>Program</label>
            <p-autoComplete
                [(ngModel)]="selectedProgramLabel"
                [suggestions]="filteredProgramOptions"
                [forceSelection]="true"
                [minQueryLength]="1"
                placeholder="Type to search programs"
                [showClear]="true"
                [disabled]="saving"
                (completeMethod)="filterProgramSuggestions($event)"
                (onSelect)="onProgramSelected()"
                (onClear)="onProgramCleared()"></p-autoComplete>
            <label>Model Year</label>
            <p-select [options]="modelYearSelectOptions"
                      optionLabel="label"
                      optionValue="value"
                      [(ngModel)]="selectedModelYearId"
                      [disabled]="saving"
                      (onChange)="onModelYearSelected()"></p-select>
            <p-button label="Preview Count" type="button" [disabled]="!canPreviewGroup || saving"
                      (click)="previewGroup()"></p-button>
            @if (groupPreviewCount !== null) {
                <span class="group-preview-count">This will add approximately {{ groupPreviewCount }} ICDs.</span>
            }
            <p-button label="Add Group" type="button" [disabled]="!canPreviewGroup || saving"
                      (click)="confirmAddGroupSubscription()"></p-button>
        </div>
    </div>

    <div class="table-header-row">
        <h3>Effective Subscriptions</h3>
        <a [href]="subscriptionSearchGridUrl" target="_blank" rel="noopener noreferrer" class="view-in-search-grid-link">
            View in ICD Search Grid
        </a>
    </div>

    <p-table [value]="subscriptions"
             [loading]="loading"
             [stripedRows]="true"
             [showGridlines]="true"
             [tableStyle]="{'min-width': '60rem'}"
             class="icd-subscriptions-table">
        <ng-template pTemplate="header">
            <tr>
                <th>Actions</th>
                <th pSortableColumn="icdId">ICD ID <p-sortIcon field="icdId"></p-sortIcon></th>
                <th pSortableColumn="icdName">Name <p-sortIcon field="icdName"></p-sortIcon></th>
                <th pSortableColumn="programName">Program <p-sortIcon field="programName"></p-sortIcon></th>
                <th pSortableColumn="modelYear">Model Year <p-sortIcon field="modelYear"></p-sortIcon></th>
                <th pSortableColumn="stage">Stage <p-sortIcon field="stage"></p-sortIcon></th>
                <th pSortableColumn="source">Source <p-sortIcon field="source"></p-sortIcon></th>
                <th pSortableColumn="icdCount">ICD Count <p-sortIcon field="icdCount"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td class="actions-col">
                    @if (isGroupSource(row.source)) {
                        <p-button label="Remove Group" severity="danger" type="button"
                                  (click)="removeGroupSubscription(row)"></p-button>
                    } @else {
                        <p-button label="Remove" severity="danger" type="button"
                                  (click)="removeIndividualSubscription(row.icdId)"></p-button>
                    }
                </td>
                <td>{{ row.icdId }}</td>
                <td>{{ row.icdName }}</td>
                <td>{{ row.programName }}</td>
                <td>{{ row.modelYear }}</td>
                <td>{{ row.stage }}</td>
                <td>{{ sourceLabel(row) }}</td>
                <td>{{ row.icdCount }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8" class="empty-message">You have no ICD subscriptions yet.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
}
